import { useQuery } from '@tanstack/react-query';
import { profileComparisonApi } from '../api';
import type { ProfileComparisonParams } from '../api/types';

const PROFILE_COMPARISON_KEY = 'profileComparison';

export const useComparisonDemographics = (params: ProfileComparisonParams) => {
  return useQuery({
    queryKey: [PROFILE_COMPARISON_KEY, 'demographics', params],
    queryFn: () => profileComparisonApi.getDemographics(params),
    staleTime: 5 * 60 * 1000,
    enabled: params.departments.length > 0 && params.client_id !== undefined,
  });
};

export const useComparisonHrv = (params: ProfileComparisonParams) => {
  return useQuery({
    queryKey: [PROFILE_COMPARISON_KEY, 'hrv', params],
    queryFn: () => profileComparisonApi.getHrv(params),
    staleTime: 5 * 60 * 1000,
    enabled: params.departments.length > 0 && params.client_id !== undefined,
  });
};

export const useComparisonRecovery = (params: ProfileComparisonParams) => {
  return useQuery({
    queryKey: [PROFILE_COMPARISON_KEY, 'recovery', params],
    queryFn: () => profileComparisonApi.getRecovery(params),
    staleTime: 5 * 60 * 1000,
    enabled: params.departments.length > 0 && params.client_id !== undefined,
  });
};

export const useComparisonStrain = (params: ProfileComparisonParams) => {
  return useQuery({
    queryKey: [PROFILE_COMPARISON_KEY, 'strain', params],
    queryFn: () => profileComparisonApi.getStrain(params),
    staleTime: 5 * 60 * 1000,
    enabled: params.departments.length > 0 && params.client_id !== undefined,
  });
};

export const useComparisonSleep = (params: ProfileComparisonParams) => {
  return useQuery({
    queryKey: [PROFILE_COMPARISON_KEY, 'sleep', params],
    queryFn: () => profileComparisonApi.getSleep(params),
    staleTime: 5 * 60 * 1000,
    enabled: params.departments.length > 0 && params.client_id !== undefined,
  });
};
